export default {
  Themes: {
    LIST: "/settings-themes",
    NEW: "/settings-themes/new",
    EDIT: "/settings-themes/edit/:id",
    URLS: "/themes/urls",
  },
};
